module.exports = __webpack_public_path__ + "img/illustration.6e4cce55.png";